function JiraIcon({ height = '29', width = '27', color = '#1868DB' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        id="Vector"
        d="M8.90881 19.6757H6.52038C2.91782 19.6757 0.333496 17.3766 0.333496 14.0098H13.1776C13.8428 14.0098 14.2734 14.5032 14.2734 15.2008V28.667C11.0626 28.667 8.90881 25.9574 8.90881 22.1801V19.6757ZM15.2528 12.9836H12.8633C9.26185 12.9836 6.67753 10.726 6.67753 7.35913H19.5206C20.1858 7.35913 20.6561 7.80999 20.6561 8.5087V21.9748C17.4454 21.9748 15.2528 19.2652 15.2528 15.4879V12.9836ZM21.6356 6.33294H19.2461C15.6436 6.33294 13.0592 4.03381 13.0592 0.666992H25.9034C26.5685 0.666992 27.0002 1.15934 27.0002 1.81656V15.2827C23.7894 15.2827 21.6356 12.5731 21.6356 8.79581V6.33294Z"
        fill={color}
      />
    </svg>
  );
}
export default JiraIcon;
